import { Typography } from '@mui/joy';
import { isArray } from 'lodash';
import { isValidElement, ReactNode } from 'react';

export const getValueContent = (value: ReactNode) => {
  if (isValidElement(value)) {
    return value;
  }

  if (isArray(value)) {
    return value.map((item, index) => <Typography key={index}>{item}</Typography>);
  }

  return <Typography sx={{ whiteSpace: 'initial' }}>{value}</Typography>;
};
